'use client';

import { c as _c } from "react/compiler-runtime";
import { Bar, Progress } from '@bprogress/next';
import { ProgressProvider } from '@bprogress/next/app';
import { PropsWithChildren } from 'react';
export default function RouteProgressProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showSpinner: false,
      template: null,
      easing: "linear",
      speed: 250,
      trickle: true,
      trickleSpeed: 120,
      minimum: 0.08
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Progress><Bar style={{
        background: "linear-gradient(90deg, #5fb3ff 0%, #5fb3ff 10%, #9d5cff 50%, #ff6ef0 90%, #ff6ef0 100%)",
        backgroundSize: "300% 100%",
        animation: "gradientFlow 2.5s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      }} /></Progress>;
    t3 = <style jsx={true} scoped={true}>{"\n          @keyframes gradientFlow {\n            0%,\n            100% {\n              background-position: 0% 50%;\n            }\n            50% {\n              background-position: 100% 50%;\n            }\n          }\n        "}</style>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <ProgressProvider height="3px" options={t1} shallowRouting={true} startPosition={0.5}>{t2}{t3}{children}</ProgressProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}